import { connectIntervalPoller } from '@capture/client/API/services/IntervalPoller'
import { connectSyncers } from '@capture/client/API/syncers'
import { connectAnalyticsConsent } from '@capture/client/analytics/analyticsConsent'
import { analyticsMiddleware } from '@capture/client/analytics/analyticsMiddleware'
import { makeSentryMiddleware } from '@capture/client/errorReporting/sentryMiddleware'
import { makeStore } from '@capture/client/state'
import { albumMiddleware } from '@capture/client/state/album/autoAlbumMiddleware'
import { carouselViewMiddleware } from '@capture/client/state/carouselViewer/carouselMiddleware'
import { connectUserGuarantee } from '@capture/client/state/currentUser'
import { changesSyncerMiddleware } from '@capture/client/state/job/changesSyncerMiddleware'
import { addModalListeners } from '@capture/client/state/modalManager/modalManagerSlice'
import { popupMiddleware } from '@capture/client/state/popup/popupMiddleware'
import { addResumeListeners } from '@capture/client/state/resume/resumeSlice'
import { trashMiddleware } from '@capture/client/state/trash/trashMiddleware'
import { connectUploader } from '@capture/client/state/uploader/uploadQueue'
import type { Store, TypedStartListening } from '@reduxjs/toolkit'
import { createListenerMiddleware } from '@reduxjs/toolkit'
import { connectServiceProvider } from '@capture/client/API/HostProvider'
import type { RootState } from '@capture/client/state/store'
import { SENTRY_DSN__FULL_WEB } from './config/constants'

const listenerMiddleware = createListenerMiddleware()
export const startAppListening =
    listenerMiddleware.startListening as TypedStartListening<RootState>

// register the resume listeners
addResumeListeners(startAppListening)
addModalListeners(startAppListening)

let store: Store | null = null

export function getStore() {
    if (!store) {
        store = makeStore(
            [
                makeSentryMiddleware({ dsn: SENTRY_DSN__FULL_WEB }),
                analyticsMiddleware,
                changesSyncerMiddleware,
                popupMiddleware,
                carouselViewMiddleware,
                albumMiddleware,
                trashMiddleware,
            ],
            [
                connectUploader,
                connectServiceProvider,
                connectSyncers,
                connectUserGuarantee,
                connectIntervalPoller,
                connectAnalyticsConsent,
            ],
            listenerMiddleware,
        )
    }

    return store
}
